import { es } from 'date-fns/locale/es';
import { ptBR } from 'date-fns/locale/pt-BR';
import type { Language } from '../i18n/translations';

export const DATE_LOCALES: Record<Language, typeof es | undefined> = {
  en: undefined,
  es,
  pt: ptBR,
};
